export default function (Component) {
       if(!Component.options.wxsCallMethods){
         Component.options.wxsCallMethods = []
       }
       Component.options.wxsCallMethods.push('wxsCall')
     }